export const iconFontAwesomeEditingCrop = (
	<i className="fa-solid fa-crop"></i>
);
